(() => {
  'use strict';
  document.querySelectorAll('[data-pig-carousel]').forEach(section => {
    const track = section.querySelector('[data-pig-carousel-track]');
    const previous = section.querySelector('[data-pig-carousel-prev]');
    const next = section.querySelector('[data-pig-carousel-next]');
    const status = section.querySelector('[data-pig-carousel-status]');
    if (!track || !previous || !next || !status) return;
    const cards = Array.from(track.children);
    const mobile = window.matchMedia('(max-width: 760px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let scheduled = false;
    const offset = index => cards[index].offsetLeft - cards[0].offsetLeft;
    const update = () => {
      scheduled = false;
      if (!mobile.matches) return;
      current = cards.reduce((closest, card, index) => Math.abs(offset(index) - track.scrollLeft) < Math.abs(offset(closest) - track.scrollLeft) ? index : closest, 0);
      previous.disabled = current === 0;
      next.disabled = current === cards.length - 1;
      status.textContent = `${current + 1} / ${cards.length}`;
    };
    const move = direction => {
      const index = Math.max(0, Math.min(cards.length - 1, current + direction));
      track.scrollTo({left: offset(index), behavior: reduced.matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
    }, {passive: true});
    track.addEventListener('keydown', event => {
      if (!mobile.matches || event.target !== track) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    mobile.addEventListener('change', update);
    update();
  });
  const hero = document.querySelector('[data-pig-hero-video]');
  const motion = document.querySelector('[data-pig-motion]');
  if (hero && motion) {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let requestedPause = reduced.matches || Boolean(navigator.connection && navigator.connection.saveData);
    let visible = false;
    const label = () => {
      motion.textContent = hero.paused ? 'Play motion' : 'Pause motion';
      motion.setAttribute('aria-label', hero.paused ? 'Play background video' : 'Pause background video');
    };
    const play = () => {
      if (!hero.src) { hero.src = hero.dataset.videoUrl; hero.load(); }
      hero.muted = true;
      hero.play().then(label).catch(label);
    };
    motion.hidden = false;
    label();
    motion.addEventListener('click', () => {
      requestedPause = !hero.paused;
      if (requestedPause) hero.pause(); else play();
      label();
    });
    hero.addEventListener('play', label);
    hero.addEventListener('pause', label);
    reduced.addEventListener('change', event => {
      requestedPause = event.matches;
      if (requestedPause) hero.pause(); else if (visible) play();
      label();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) hero.pause(); else if (visible && !requestedPause) play();
    });
    new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible && !requestedPause && !document.hidden) play(); else hero.pause();
    }, {threshold: 0.15}).observe(hero);
  }
  const form = document.querySelector('.pig-catering__form');
  if (!form) return;
  const picker = document.querySelector('[data-pig-dish-picker]');
  const openPicker = form.querySelector('[data-pig-open-dishes]');
  if (picker && openPicker && typeof picker.showModal === 'function') {
    const rows = Array.from(picker.querySelectorAll('[data-pig-dish-row]'));
    const search = picker.querySelector('[data-pig-dish-search]');
    const categories = picker.querySelector('[data-pig-dish-categories]');
    const menuScroll = picker.querySelector('[data-pig-dish-scroll]');
    let hasBrowsedMenu = false;
    menuScroll.addEventListener('scroll', () => {
      if (menuScroll.scrollTop >= picker.querySelector('.pig-dish-picker__header').offsetHeight - 1) hasBrowsedMenu = true;
    }, {passive: true});
    const menuList = picker.querySelector('[data-pig-dish-list]');
    const sizeMenu = () => {
      menuList.style.minHeight = `${Math.max(0, menuScroll.clientHeight - picker.querySelector('.pig-dish-picker__tools').offsetHeight)}px`;
    };
    new ResizeObserver(sizeMenu).observe(menuScroll);
    const resetMenuScroll = () => {
      // Keep the intro out of the way when switching categories after browsing.
      menuScroll.scrollTop = hasBrowsedMenu ? picker.querySelector('.pig-dish-picker__header').offsetHeight : 0;
    };
    const empty = picker.querySelector('[data-pig-dish-empty]');
    const count = picker.querySelector('[data-pig-dish-count]');
    const error = picker.querySelector('[data-pig-dish-error]');
    const summary = form.querySelector('[data-pig-dish-summary]');
    const requestedDishes = form.querySelector('[data-pig-requested-dishes]');
    const committed = new Map();
    let previousOverflow = '';
    let activeCategory = '';
    const rowCategories = new Map(rows.map(row => {
      let values = [];
      try { values = JSON.parse(row.dataset.dishCategories || '[]'); } catch (_) {}
      return [row, Array.isArray(values) ? values : []];
    }));
    const preferredOrder = ['Specialty Pizzas', 'Charcoal BBQ Combos', 'Charcoal BBQ', 'Salads', 'Stone Oven Baked', 'Pasta', 'Sandwiches', 'Sides', 'Soups', 'Drinks'];
    const categoryNames = Array.from(new Set(Array.from(rowCategories.values()).flat())).sort((a, b) => {
      const rank = name => preferredOrder.includes(name) ? preferredOrder.indexOf(name) : preferredOrder.length;
      return rank(a) - rank(b) || a.localeCompare(b);
    });
    const categoryButtons = [];
    const quantity = row => Number(row.querySelector('[data-pig-dish-quantity]').value || 0);
    const valid = row => Number.isInteger(quantity(row)) && quantity(row) >= 0 && quantity(row) <= 9999;
    const update = () => {
      let choices = 0;
      let total = 0;
      rows.forEach(row => {
        const value = quantity(row);
        row.querySelector('[data-pig-quantity-minus]').disabled = value <= 0;
        row.querySelector('[data-pig-quantity-plus]').disabled = value >= 9999;
        row.classList.toggle('is-selected', value > 0 && valid(row));
        if (value > 0 && valid(row)) { choices++; total += value; }
      });
      count.textContent = choices ? `${choices} menu ${choices === 1 ? 'choice' : 'choices'} · ${total.toLocaleString()} ${total === 1 ? 'item' : 'items'}` : 'No dishes selected yet';
    };
    const filter = () => {
      const query = search.value.trim().toLocaleLowerCase();
      let matches = 0;
      rows.forEach(row => {
        row.hidden = (activeCategory !== '' && !rowCategories.get(row).includes(activeCategory)) || !row.dataset.dishName.toLocaleLowerCase().includes(query);
        if (!row.hidden) matches++;
      });
      empty.hidden = matches > 0;
    };
    if (categories) {
      ['', ...categoryNames].forEach(category => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = category || 'All dishes';
        button.setAttribute('aria-pressed', String(category === activeCategory));
        button.addEventListener('click', () => {
          activeCategory = category;
          categoryButtons.forEach(entry => entry.button.setAttribute('aria-pressed', String(entry.category === category)));
          search.value = '';
          search.placeholder = category ? 'Search this category…' : 'Search pizza, kabob, salad…';
          filter();
          resetMenuScroll();
          const railBounds = categories.getBoundingClientRect();
          const pillBounds = button.getBoundingClientRect();
          if (pillBounds.left < railBounds.left) categories.scrollLeft -= railBounds.left - pillBounds.left;
          else if (pillBounds.right > railBounds.right) categories.scrollLeft += pillBounds.right - railBounds.right;
        });
        categories.appendChild(button);
        categoryButtons.push({category, button});
      });
      // Start the complete menu with pizza and group-friendly choices.
      const rank = row => Math.min(preferredOrder.length, ...rowCategories.get(row).map(name => {
        const index = preferredOrder.indexOf(name);
        return index < 0 ? preferredOrder.length : index;
      }));
      rows.sort((a, b) => rank(a) - rank(b) || a.dataset.dishName.localeCompare(b.dataset.dishName));
      picker.querySelector('[data-pig-dish-list]').append(...rows, empty);
    }
    openPicker.addEventListener('click', () => {
      rows.forEach(row => { row.querySelector('[data-pig-dish-quantity]').value = committed.get(row.dataset.dishId)?.quantity || 0; });
      search.value = '';
      activeCategory = '';
      hasBrowsedMenu = false;
      categoryButtons.forEach(entry => entry.button.setAttribute('aria-pressed', String(entry.category === '')));
      if (categories) categories.scrollLeft = 0;
      search.placeholder = 'Search pizza, kabob, salad…';
      error.hidden = true;
      update(); filter();
      previousOverflow = document.body.style.overflow;
      picker.showModal();
      sizeMenu();
      document.body.style.overflow = 'hidden';
      menuScroll.scrollTop = 0;
      const initialFocus = window.matchMedia('(max-width: 760px)').matches ? picker.querySelector('[data-pig-close-dishes]') : search;
      initialFocus.focus({preventScroll: true});
      document.dispatchEvent(new CustomEvent('pig:dish-picker-toggle'));
    });
    picker.querySelector('[data-pig-close-dishes]').addEventListener('click', () => picker.close());
    picker.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); picker.close(); }
    });
    picker.addEventListener('click', event => {
      if (event.target !== picker) return;
      const bounds = picker.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) picker.close();
    });
    picker.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      openPicker.focus({preventScroll: true});
      document.dispatchEvent(new CustomEvent('pig:dish-picker-toggle'));
    });
    search.addEventListener('input', () => { filter(); resetMenuScroll(); });
    rows.forEach(row => {
      const input = row.querySelector('[data-pig-dish-quantity]');
      input.addEventListener('input', () => { error.hidden = true; update(); });
      row.querySelector('[data-pig-quantity-minus]').addEventListener('click', () => {
        input.value = Math.max(0, (valid(row) ? quantity(row) : 0) - 1);
        error.hidden = true; update();
      });
      row.querySelector('[data-pig-quantity-plus]').addEventListener('click', () => {
        input.value = Math.min(9999, (valid(row) ? quantity(row) : 0) + 1);
        error.hidden = true; update();
      });
    });
    picker.querySelector('[data-pig-apply-dishes]').addEventListener('click', () => {
      const invalid = rows.find(row => !valid(row));
      if (invalid) {
        search.value = ''; activeCategory = '';
        categoryButtons.forEach(entry => entry.button.setAttribute('aria-pressed', String(entry.category === '')));
        filter(); error.hidden = false;
        invalid.querySelector('[data-pig-dish-quantity]').focus();
        return;
      }
      committed.clear();
      rows.forEach(row => {
        if (quantity(row) > 0) committed.set(row.dataset.dishId, {name: row.dataset.dishName, quantity: quantity(row)});
      });
      summary.replaceChildren();
      const lines = [];
      committed.forEach(choice => {
        const line = `${choice.quantity} × ${choice.name}`;
        const item = document.createElement('li');
        item.textContent = line;
        summary.appendChild(item);
        lines.push(line);
      });
      summary.hidden = committed.size === 0;
      requestedDishes.value = lines.length ? 'Estimated menu wish list — please call to finalize sizes, flavors, quantities, portions, availability and pricing.\n' + lines.join('\n') : '';
      openPicker.firstChild.textContent = committed.size ? 'Edit dishes & quantities ' : 'Choose dishes & quantities ';
      document.dispatchEvent(new CustomEvent('pig:requested-dishes-changed'));
      picker.close();
    });
    form.querySelector('[data-pig-dish-request]').hidden = false;
  }
  // Bind only the catering Forms block; use its accepted success view for tracking.
  const formsContainer = document.querySelector('[data-pig-shopify-forms]');
  if (formsContainer) {
    const host = formsContainer.querySelector('[data-pig-forms-host]');
    let attachedRoot = null;
    const setField = (field, value) => {
      if (!field || field.value === value) return;
      const prototype = field.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      Object.getOwnPropertyDescriptor(prototype, 'value').set.call(field, value);
      field.dispatchEvent(new Event('input', {bubbles: true}));
      field.dispatchEvent(new Event('change', {bubbles: true}));
    };
    const progressiveForms = new WeakMap();
    const setupProgressiveForm = (root, appForm) => {
      const dateParts = Array.from(appForm.querySelectorAll('[data-testid="date-birthday"] input'));
      const guests = root.getElementById('custom#estimated_guests');
      const name = root.getElementById('first_name');
      const email = root.getElementById('email');
      const phone = root.getElementById('phone_number');
      const submit = appForm.querySelector('[type="submit"]');
      // If Shopify changes its field contract, leave its complete native form available.
      if (dateParts.length !== 3 || !guests || !name || !email || !phone || !submit) return;
      const topField = field => {
        let node = field;
        while (node && node.parentElement !== appForm) node = node.parentElement;
        return node;
      };
      let state = progressiveForms.get(appForm);
      if (!state) {
        const style = document.createElement('style');
        style.textContent = `
          [data-pig-step] { display:grid!important; grid-template-columns:minmax(0,1fr)!important; gap:16px!important; color:#222; }
          [data-pig-step] > * { grid-column:1/-1!important; min-width:0; }
          [data-pig-step="1"] > [data-pig-stage="2"], [data-pig-step="2"] > [data-pig-stage="1"],
          [data-pig-native-date], [data-pig-step] [data-pig-internal],
          [data-pig-step]:not([data-pig-details-open="true"]) > [data-pig-extra] { display:none!important; }
          [data-pig-progressive-header] { display:none!important; }
          [data-pig-step] input,[data-pig-step] textarea { font-size:16px!important;box-sizing:border-box!important; }
          .pig-steps__intro { order:-20; }
          .pig-steps__progress { display:flex; align-items:center; gap:8px; color:#6b625c; font:600 12px/1.5 Arial,sans-serif; margin:0 0 16px; }
          .pig-steps__progress span { width:22px;height:22px;display:inline-grid;place-items:center;border:1px solid #d8d0c6;border-radius:50%;font-size:11px; }
          .pig-steps__progress [aria-current="step"] { color:#a52725; }
          .pig-steps__progress [aria-current="step"] span { background:#bd302d;color:white;border-color:#bd302d; }
          .pig-steps__progress i { flex:1;height:1px;background:#e5ddd3;max-width:32px; }
          .pig-steps__title { font:700 23px/1.2 Arial,sans-serif;letter-spacing:-.02em;margin:0 0 8px; }
          .pig-steps__title:focus { outline:none; }
          .pig-steps__hint { font:400 14px/1.5 Arial,sans-serif;color:#68605a;margin:0; }
          .pig-steps__edit { border:0;padding:7px 0;background:none;color:#a52725;text-decoration:underline;text-underline-offset:3px;font:600 13px/1.5 Arial,sans-serif;cursor:pointer;min-height:36px; }
          .pig-steps__date { order:0;display:grid;gap:8px; }
          .pig-steps__date label { font:600 14px/1.4 Arial,sans-serif; }
          .pig-steps__date input { appearance:auto;box-sizing:border-box;width:100%;min-width:0;max-width:100%;min-height:52px;border:1px solid #bfb5aa;border-radius:6px;background:white;padding:11px 12px;color:#222;font:400 16px/1.4 Arial,sans-serif; }
          [data-pig-field="guests"], [data-pig-field="name"], [data-pig-field="email"] { display:flex;flex-direction:column!important;gap:8px;box-shadow:none!important; }
          [data-pig-field="guests"] > label, [data-pig-field="name"] > label, [data-pig-field="email"] > label { position:static!important;order:-1!important;transform:none!important;padding:0!important;font:600 14px/1.4 Arial,sans-serif!important;color:#222!important; }
          [data-pig-field="guests"] > input, [data-pig-field="name"] > input, [data-pig-field="email"] > input { box-sizing:border-box;min-height:52px!important;height:52px!important;border:1px solid #bfb5aa!important;border-radius:6px;padding:11px 12px!important;background:#fff;box-shadow:none!important; }
          [data-pig-field="guests"] { order:10; }
          [data-pig-field="name"] { order:20; }
          [data-pig-field="email"] { order:30; }
          [data-pig-field="phone"] { order:40; }
          [data-pig-field="occasion"] { order:50; }
          [data-pig-field="phone"] { display:flex!important;align-items:flex-end;gap:8px; }
          [data-pig-field="phone"] > .phone-country-selector { flex:0 0 74px; }
          [data-pig-field="phone"] > .phone-country-selector button { min-height:52px!important;height:52px!important; }
          [data-pig-field="phone"] > div:has(> input) { display:flex!important;flex-direction:column!important;gap:8px;flex:1;min-width:0;box-shadow:none!important; }
          [data-pig-field="phone"] > div > label { position:static!important;order:-1!important;transform:none!important;padding:0!important;font:600 14px/1.4 Arial,sans-serif!important; }
          [data-pig-field="phone"] input { box-sizing:border-box;min-height:52px!important;height:52px!important;border:1px solid #bfb5aa!important;border-radius:6px;padding:11px 12px!important;box-shadow:none!important; }

          [data-pig-step] > [data-pig-extra] { order:70; }
          .pig-steps__next { order:15; }
          .pig-steps__next, [data-pig-step] > [type="submit"] { box-sizing:border-box;width:100%;min-height:52px;border:0;border-radius:7px;padding:14px 18px;background:#bd302d;color:white;font:700 16px/1.4 Arial,sans-serif;cursor:pointer; }
          .pig-steps__next:hover, [data-pig-step] > [type="submit"]:hover { background:#952724; }
          [data-pig-step] > [type="submit"] { order:90;margin:0; }
          .pig-steps__more { order:60;display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;border:1px solid #e5ddd3;background:#faf5ee;border-radius:8px;padding:13px 14px;min-height:48px;text-align:left;color:#48413b;font:600 14px/1.4 Arial,sans-serif;cursor:pointer; }
          .pig-steps__more small { font-weight:400; }
          .pig-steps__error { color:#b82020;font:400 13px/1.5 Arial,sans-serif;margin:0; }
          [data-pig-step] > .pig-steps__note { order:95;font:400 12px/1.5 Arial,sans-serif;color:#68605a;margin:0; }
          [data-pig-step] button:focus-visible,[data-pig-step] input:focus-visible { outline:3px solid #26754a!important;outline-offset:3px; }
          [data-pig-step] [hidden] { display:none!important; }
        `;
        root.appendChild(style);
        const intro = document.createElement('div');
        intro.className = 'pig-steps__intro';
        intro.innerHTML = `<div class="pig-steps__progress" aria-label="Step 1 of 2"><b aria-current="step"><span>1</span> Event basics</b><i aria-hidden="true"></i><b><span>2</span> Contact details</b></div><h3 class="pig-steps__title" tabindex="-1">When’s your gathering?</h3><p class="pig-steps__hint">An estimate for the guest count is fine.</p><button type="button" class="pig-steps__edit" hidden>Edit date &amp; guests</button><p class="pig-steps__error" role="alert" hidden></p>`;
        const dateBox = document.createElement('div');
        dateBox.className = 'pig-steps__date';
        dateBox.dataset.pigStage = '1';
        dateBox.innerHTML = `<label for="pig-event-date">Event date</label><input type="date" id="pig-event-date" required aria-required="true">`;
        const date = dateBox.querySelector('input');
        const today = new Date();
        date.min = [today.getFullYear(),String(today.getMonth()+1).padStart(2,'0'),String(today.getDate()).padStart(2,'0')].join('-');
        if (dateParts.every(input => input.value)) date.value = `${dateParts[2].value}-${dateParts[0].value.padStart(2,'0')}-${dateParts[1].value.padStart(2,'0')}`;
        const next = document.createElement('button');
        next.type='button';next.className='pig-steps__next';next.dataset.pigStage='1';next.dataset.pigNext='';next.textContent='Continue';
        const more = document.createElement('button');
        more.type='button';more.className='pig-steps__more';more.dataset.pigStage='2';more.setAttribute('aria-expanded','false');
        more.innerHTML='<span>Add food preferences &amp; details <small>(optional)</small></span><span aria-hidden="true">＋</span>';
        const note=document.createElement('p');note.className='pig-steps__note';note.dataset.pigStage='2';note.textContent='A request starts the conversation. Our team will confirm availability, pricing, and arrangements before an order is placed.';
        appForm.prepend(intro,dateBox);appForm.append(next,more,note);
        state={step:1,intro,date,next,more,error:intro.querySelector('[role="alert"]'),guests};
        const setStep = (step, focus=true) => {
          state.step=step;appForm.dataset.pigStep=String(step);state.error.hidden=true;
          const progress=intro.querySelector('.pig-steps__progress');progress.setAttribute('aria-label',`Step ${step} of 2`);
          progress.querySelectorAll('b').forEach((b,i)=>{if(i===step-1)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');});
          const title=intro.querySelector('h3');title.textContent=step===1?'When’s your gathering?':'Where can we reach you?';
          const hint=intro.querySelector('.pig-steps__hint');
          hint.textContent=step===1?'An estimate for the guest count is fine.':`${new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',year:'numeric'}).format(new Date(date.value+'T12:00:00'))} · About ${guests.value} guests. We’ll contact you to plan the menu.`;
          intro.querySelector('.pig-steps__edit').hidden=step===1;
          if(focus) { title.focus({preventScroll:true});document.getElementById('catering-quote').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'}); }
        };
        state.setStep=setStep;
        const syncDate = () => {const [year,month,day]=date.value.split('-');[month||'',day||'',year||''].forEach((value,i)=>setField(dateParts[i],value));};
        date.addEventListener('input',syncDate);date.addEventListener('change',syncDate);
        guests.min='1';guests.step='1';guests.required=true;guests.setAttribute('aria-required','true');
        next.addEventListener('click',()=>{
          if(!date.reportValidity())return;
          guests.setCustomValidity(Number.isInteger(Number(guests.value))&&Number(guests.value)>=1?'':'Enter the estimated number of guests.');
          if(!guests.reportValidity())return;
          syncDate();setStep(2);
        });
        guests.addEventListener('input',()=>guests.setCustomValidity(''));
        intro.querySelector('.pig-steps__edit').addEventListener('click',()=>setStep(1));
        more.addEventListener('click',()=>{const open=more.getAttribute('aria-expanded')!=='true';more.setAttribute('aria-expanded',String(open));appForm.dataset.pigDetailsOpen=String(open);more.lastElementChild.textContent=open?'−':'＋';});
        progressiveForms.set(appForm,state);setStep(1,false);
      }
      const classify=(field,kind,stage,extra=false)=>{
        const node=topField(field);if(!node)return;node.dataset.pigField=kind;node.dataset.pigStage=stage;
        if(extra)node.dataset.pigExtra='';
      };
      classify(guests,'guests','1');classify(name,'name','2');classify(email,'email','2');classify(phone,'phone','2');
      name.autocomplete='given-name';email.autocomplete='email';email.inputMode='email';phone.autocomplete='tel';
      const nativeDate=topField(dateParts[0]);nativeDate.dataset.pigNativeDate='';
      const occasion=root.getElementById('custom#occasion-selector-label');if(occasion)classify(occasion,'occasion','2');
      ['company_organization','preferred_meal_time','event_city_location','menu_notes_dietary_requests'].forEach(id=>{
        const field=root.getElementById('custom#'+id);if(!field)return;classify(field,id,'2',true);
        const label=appForm.querySelector(`label[for="${field.id}"]`);
        if(label && !label.textContent.includes('(optional)'))label.textContent+=' (optional)';
      });
      const dish=appForm.querySelector('[data-pig-dish-request]');if(dish){dish.dataset.pigStage='2';dish.dataset.pigExtra='';}
      submit.dataset.pigStage='2';
      if(submit.getAttribute('aria-disabled')!=='true' && submit.textContent==='Send catering request')submit.textContent='Request a quote';
      const header=appForm.previousElementSibling;if(header && !header.classList.contains('pig-steps__intro'))header.setAttribute('data-pig-progressive-header','');
      ['custom#landing_page','custom#requested_dishes_and_quantities'].forEach(id=>{const field=root.getElementById(id);if(field)topField(field).dataset.pigInternal='';});
      const invalidExtra=appForm.querySelector('[data-pig-extra] [aria-invalid="true"]');
      if(invalidExtra){appForm.dataset.pigDetailsOpen='true';state.more.setAttribute('aria-expanded','true');state.more.lastElementChild.textContent='−';}
      if(state.step===2 && nativeDate.querySelector('[aria-invalid="true"]')){state.setStep(1);state.error.textContent='Please check your event date and try again.';state.error.hidden=false;}
    };
    const bind = () => {
      const embed = host.querySelector('shopify-forms-embed');
      const root = embed && embed.shadowRoot;
      if (!root) return;
      if (root !== attachedRoot) {
        attachedRoot = root;
        const style = document.createElement('style');
        style.textContent = `:host{--inline-container-max-width:100%;--forms-body-font:normal 400 16px Arial,sans-serif;--forms-base-font-size:16px} [data-testid="form"]{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:16px} [data-testid="form"]>div:has(shop-lead-capture){display:none} [data-testid="date-birthday"],[data-testid="form"]>div:has(textarea),[data-testid="form"]>button,[data-testid="form"]>.pig-catering__dish-request{grid-column:1/-1} [data-testid="form"]>div:has(input[id="custom#landing_page"]){display:none} [data-testid="form"]>div:has(textarea[name="custom#requested_dishes_and_quantities"]){display:none} .pig-catering__dish-request{border:1px solid #dfd3c8;border-radius:12px;background:#faf6f0;padding:18px} .pig-catering__dish-request p{line-height:1.5;margin:10px 0;font-size:14px} .pig-catering__field-label{font-weight:700}.pig-catering__field-label small{font-weight:400}.pig-catering__choose-dishes{display:flex;justify-content:space-between;align-items:center;width:100%;padding:15px;border:1px solid #c52b2b;border-radius:8px;color:#b82020;background:white;font:700 16px Arial;cursor:pointer} .pig-catering__dish-summary{padding-left:20px;font-size:14px} [hidden]{display:none!important} @media(max-width:520px){[data-testid="form"]{grid-template-columns:minmax(0,1fr);gap:14px}}`;
        root.appendChild(style);
        root.addEventListener('submit', event => {
          const activeForm=root.querySelector('form[data-testid="form"]');
          if(activeForm?.dataset.pigStep==='1'){
            event.preventDefault();event.stopImmediatePropagation();activeForm.querySelector('[data-pig-next]')?.click();return;
          }
          document.dispatchEvent(new CustomEvent('pig:catering-request-started'));
        }, true);
        new MutationObserver(bind).observe(root, {childList:true,subtree:true,attributes:true,attributeFilter:['data-current-step','aria-invalid']});
      }
      const appForm = root.querySelector('form[data-testid="form"]');
      if (appForm) {
        root.querySelectorAll('textarea[name^="custom#"]').forEach(field => { if (!field.id) field.id = field.name; });
        formsContainer.querySelector('[data-pig-forms-loading]').hidden = true;
        const target = root.querySelector('textarea[name="custom#requested_dishes_and_quantities"]');
        const panel = formsContainer.querySelector('[data-pig-dish-request]');
        if (target && panel) target.parentElement.before(panel);
        setField(target, requestedMenuValue());
        setField(root.getElementById('custom#landing_page'), location.origin + location.pathname);
        setupProgressiveForm(root,appForm);
      }
      const title = root.querySelector('h2');
      if (!appForm && title && title.textContent.trim() === 'Your catering request is sent' && !formsContainer.querySelector('[data-pig-catering-success]')) {
        const marker = document.createElement('span');
        marker.hidden = true; marker.setAttribute('data-pig-catering-success', '');
        formsContainer.appendChild(marker);
        formsContainer.setAttribute('data-pig-submission-accepted', 'true');
        document.dispatchEvent(new CustomEvent('pig:catering-request-accepted'));
      }
    };
    const requestedMenuValue = () => document.querySelector('[data-pig-requested-dishes]')?.value || attachedRoot?.querySelector('[data-pig-requested-dishes]')?.value || '';
    document.addEventListener('pig:requested-dishes-changed', bind);
    new MutationObserver(bind).observe(host, {childList:true,subtree:true});
    document.querySelectorAll('[data-pig-occasion]').forEach(link => link.addEventListener('click', () => {
      const toggle = attachedRoot?.querySelector('button[aria-labelledby="custom#occasion-selector-label custom#occasion-selector-value"]');
      if (!toggle) return;
      const selectChoice = () => {
        const choice = Array.from(attachedRoot.querySelectorAll('[role="option"]')).find(option => option.textContent.trim() === link.dataset.pigOccasion);
        if (!choice) return false;
        choice.click(); return true;
      };
      if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
      if (!selectChoice()) {
        const optionsObserver = new MutationObserver(() => { if (selectChoice()) optionsObserver.disconnect(); });
        optionsObserver.observe(attachedRoot, {childList:true,subtree:true});
        setTimeout(() => optionsObserver.disconnect(), 2000);
      }
    }));
    const timer = setInterval(() => { bind(); if (attachedRoot) clearInterval(timer); }, 250);
    setTimeout(() => clearInterval(timer), 30000);
    bind();
  }

  const occasion = form.querySelector('select[name="contact[Occasion]"]');
  document.querySelectorAll('[data-pig-occasion]').forEach(link => {
    link.addEventListener('click', () => {
      if (!occasion) return;
      occasion.value = link.dataset.pigOccasion;
      occasion.dispatchEvent(new Event('change', {bubbles: true}));
    });
  });
  const sticky = document.querySelector('[data-pig-sticky]');
  const heroActions = document.querySelector('.pig-catering__hero .pig-catering__actions');
  if (sticky && heroActions) {
    let heroActionsVisible = true;
    let formVisible = false;
    const success = () => Boolean(form.querySelector('[data-pig-catering-success]'));
    const updateSticky = () => {
      sticky.hidden = heroActionsVisible || formVisible || success() || Boolean(picker?.open) || form.contains(document.activeElement);
    };
    // Keep a second CTA available while browsing, but leave the form unobstructed.
    new IntersectionObserver(entries => {
      heroActionsVisible = entries[0].isIntersecting;
      updateSticky();
    }).observe(heroActions);
    new IntersectionObserver(entries => {
      formVisible = entries[0].isIntersecting;
      updateSticky();
    }, {rootMargin: '0px 0px -100px 0px'}).observe(form);
    form.addEventListener('focusin', updateSticky);
    form.addEventListener('focusout', () => requestAnimationFrame(updateSticky));
    document.addEventListener('pig:dish-picker-toggle', updateSticky);
    document.addEventListener('pig:catering-request-accepted', updateSticky);
  }
  const date = form.querySelector('input[type="date"]');
  if (date) {
    const now = new Date();
    date.min = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
  }
  // A success is rendered by Shopify after accepting the native contact form.
  // The Google Ads conversion listener is configured separately after API setup.
  if (form.querySelector('[data-pig-catering-success]')) {
    document.dispatchEvent(new CustomEvent('pig:catering-request-accepted'));
  }
})();
